// extracted by css-extract-rspack-plugin
export default {"root":"vBgcbwS9SvkQPK5q","badge":"OP8lmBZfyFMMJAiI"};